import classNames from "classnames";

export const articleWrapper = classNames([
    "w-full",
    "p-10",
])

export const articleContainer = classNames([
    "w-full",
    "max-w-[900px]",
    "ml-auto",
    "mr-auto",
    "mt-14",
    "pl-4",
    "pr-4",
])

export const articleItem = classNames([
    /* mobile-lg */
    "mobile-lg:flex-row",
    "mobile-lg:items-center",
    "mobile-lg:justify-start",
    "mobile-lg:text-left",
    /* All */
    "text-center",
    "flex",
    "flex-col",
    "items-center",
    "justify-center",
    "mb-5",
    "shadow-lg",
    "p-10",
    "rounded-lg"
])

export const articleImg = classNames([
    /* mobile-lg */
    "mobile-lg:mb-0",
    "mobile-lg:mr-10",
    "mobile-lg:ml-0",
    /* All */
    "mb-5",
    "w-full",
    "max-w-[110px]",
    "mr-auto",
    "ml-auto",
])

export const articleTitle = classNames([
    /* Mobile lg */
    "mobile-lg:text-lg",
    /* All */
    "text-base",
    "font-bold",
    "hover:text-accent",
    "hover:decoration-1",
    "hover:underline",
    "cursor-pointer",
])

export const articleSource = classNames([
    "text-sm",
    "text-primary",
    "hover:underline",
    "mt-2"
])

export const  articleContent = classNames([
    "text-sm",
    "mt-2"
])